import { el, clear } from "../dom.js";

// El número de preguntas, CONTADO del banco. Antes decía «10 to 15 minutes»,
// escrito cuando había siete situaciones; al pasar a dieciséis la frase quedó
// desfasada y nadie se enteró, porque una promesa de duración no la comprueba
// nada. Un recuento sí se puede comprobar, y hay una guarda que lo hace.
import { DRAFT_SITUATIONS } from "../../content/situations/draft-situations.js";
import { SITUATIONS_NINE } from "../../content/situations/situations-nine.js";
const REQUIRED_SITUATIONS = [...DRAFT_SITUATIONS, ...SITUATIONS_NINE].filter((s) => s.required).length;

export function renderIntro(container: HTMLElement, onStart: () => void): void {
  clear(container);
  const screen = el("section", { className: "screen" }, [
    el("span", { className: "eyebrow" }, ["Inner Map"]),
    el("h1", {}, ["A hypothesis, not a verdict."]),
    el("p", { className: "lede" }, [
      "Inner Map puts forward a hypothesis about a pattern. It does not diagnose, and it does not decide who you are.",
    ]),
    el("p", {}, [
      "It works from situations and answers, not from self-description. The result can stay open if the evidence isn't enough to lean either way — that is a valid outcome too, not a failure.",
    ]),
    el("p", {}, [
      `It is ${REQUIRED_SITUATIONS} questions, plus a few more if two hypotheses stay close. At any point you can go back, change an answer, or question and reject the final result.`,
    ]),
    el(
      "button",
      { className: "btn", type: "button" },
      ["Start"],
    ),
  ]);
  const button = screen.querySelector("button")!;
  button.addEventListener("click", onStart);
  container.append(screen);
}
